export const trackGoogleAnalytics = (): void => {
	// Track google analytics without specific userIDs (how we were doing it before big herballife event, just general
	// tracking)

	/*
	This has been deprecated since it's no longer valid Google Analytics code. Leaving this function in place for when we 
	figure out what we need to do here.

	window.ga("create", "UA-17269713-1", "auto");
	window.ga("send", "pageview");

	*/
};